export default {
  label: '中级工程师',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '通常负责复杂的设计任务和项目管理',
          id: '0-1-1',
        }
      ]
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '负责复杂机械装置的设计、安装、试运行和操作规程的制定',
          id: '0-2-1',
        },
        {
          label: '进行技术改造、预防性维修和设备升级',
          id: '0-2-2',
        },
        {
          label: '指导初级技术员完成具体任务',
          id: '0-2-3',
        },
        {
          label: '参与项目管理，协调团队工作',
          id: '0-2-4',
        }
      ]
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备较强的机械设计理论水平和协调沟通能力',
          id: '0-3-1',
        },
        {
          label: '熟练掌握三维设计软件和自动化领域知识',
          id: '0-3-2',
        },
        {
          label: '具备独立完成复杂设计任务的能力',
          id: '0-3-3',
        },
        {
          label: '具有良好的项目管理和团队协作能力',
          id: '0-3-4',
        }
      ]
    }
  ]
}